import type { GlobalConfig } from '../@types/context/global-config.types';
import type { MyPageConfig } from '../@types/context/my-page-config.types';
import type { ProductConfig } from '../@types/context/product-config.types';
import type { ProductCreditCardConfig } from '../@types/context/product-credit-card-config.types';
import type { ProductSecuredLoanConfig } from '../@types/context/product-secured-loan-config.types';
import type { ProductUnsecuredLoanConfig } from '../@types/context/product-unsecured-loan-config.types';
import type { SiteConfig } from '../@types/context/site-config.types';
import { contactZmartaNoConfig } from './presets/contact-zmarta-no.config';
import { creditCardNoConfig } from './presets/credit-card-no.config';
import { globalNo } from './presets/global-no.config';
import { myPageOffersConfig } from './presets/mypage-offers.config';
import { productConfigNo } from './presets/product-config.preset';
import { organisationZmartaNoConfig } from './presets/organisation-zmarta-no.config';
import { securedLoanCaseConfig } from './presets/secured-loan-case.config';
import { securedLoanNoConfig } from './presets/secured-loan-no.config';
import { serviceTrustpilotAxoConfig } from './presets/service-trustpilot-axo.config';
import { sitePathZmartaNoConfig } from './presets/site-path-zmarta-no.config';
import { unsecuredLoansBrokerCustomFields } from './presets/unsecured-loans-broker-custom-fields.config';
import { unsecuredLoansNoConfig } from './presets/unsecured-loans-no.config';

export const global: GlobalConfig = {
  brand: 'centum.no',
  ...globalNo,
};

export const site: SiteConfig = {
  domain: 'centum.no',
  name: 'Centum',
  theme: {
    name: 'centum',
    brand: 'centum.axo',
  },
  ...sitePathZmartaNoConfig,
  ...organisationZmartaNoConfig,
  ...contactZmartaNoConfig,
  services: {
    trustpilot: {
      ...serviceTrustpilotAxoConfig,
      // businessUnitId: '4e0c602a0000640005100504', // centum trustpilot id fails to fetch data
      businessUnitId: '5526aba10000ff00057ea771', // use zmarta.no instead
      showInForms: true,
    },
    gtm: 'GTM-5S75TD5D',
    ga: 'G-3S6E9KW16R',
    launchDarkly: {
      enabled: true,
    },
  },
};

export const productUnsecuredLoan: ProductUnsecuredLoanConfig = {
  ...unsecuredLoansNoConfig,
  fields: unsecuredLoansBrokerCustomFields,
};

export const productSecuredLoan: ProductSecuredLoanConfig = {
  ...securedLoanNoConfig,
  ...securedLoanCaseConfig,
};

export const productCreditCard: ProductCreditCardConfig = {
  ...creditCardNoConfig,
};

export const myPage: MyPageConfig = {
  options: {
    hasHighCostWarning: false,
    isCreditCardRecommendedVisible: false,
    creditCard: { hasApplyForm: true },
    ...myPageOffersConfig,
  },
  externalLinks: [
    { key: 'elskling', loginUrl: 'https://elskling.no' },
  ],
};

export const product: ProductConfig = productConfigNo;
